module.exports = __webpack_public_path__ + "svg/new-diners-small.a27aaae641d3fe95f83d71b1c1ffaa1c.svg";